(function () {
    /**
     * Displays dialer for incoming calls and handles some basic logic.
     * Opened by $uibModal when call request is received in CallService.
     */
    angular.module('tradersyard').component('tyIncomingCallModal', {
        // language=HTML
        template:
            '<ty-call-dialer\n    meeting-id="$ctrl.meetingId"\n    call-type="$ctrl.callType"\n    call-status="$ctrl.callStatus"\n    user-name="$ctrl.userName"\n    user-image="$ctrl.userImage"\n    on-accept="$ctrl.onAccept()"\n    on-reject="$ctrl.onReject()"\n    on-close="$ctrl.onClose()"\n>\n</ty-call-dialer>',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        },
        controller: IncomingCallModalCtrl,
    });

    IncomingCallModalCtrl.$inject = ['CallService'];

    function IncomingCallModalCtrl(CallService) {
        var ctrl = this;

        // region props

        ctrl.meetingId = 0;

        /**
         * Call type. In this case it will only be `"incoming"`.
         * @type {string|"incoming"|"outgoing"}
         */
        ctrl.callType = 'incoming';

        /**
         * @type {string|"calling"|"rejected"|"timeout"}
         */
        ctrl.callStatus = 'calling';

        ctrl.userName = '';
        ctrl.userImage = '';

        // endregion

        ctrl.$onInit = $onInit;
        ctrl.$onDestroy = $onDestroy;

        ctrl.onAccept = onAccept;
        ctrl.onReject = onReject;
        ctrl.onEnded = onEnded;
        ctrl.onClose = onClose;

        // region De/Initialization

        function $onInit() {
            // assigns controller values from `resolve.params`.
            // We are opening this component with $uibModal, and it's how params are passed ¯\_(ツ)_/¯
            angular.extend(ctrl, ctrl.resolve.params);

            // Change the UI if the Caller ends the call before we have time to answer...
            CallService.onceMeetingCallEnd(ctrl.meetingId).then(callStop);

            // ... or the call times-out.
            CallService.onceMeetingCallTimeout(ctrl.meetingId).then(callStop);

            // Stop calling if we answered in other client (AgenaTrader (AT), Meeting Client (MC), browser tab)
            CallService.onceMeetingCallReplied(ctrl.meetingId).then(onClose);
        }

        /**
         * Called when modal is closed. Perform cleanup.
         */
        function $onDestroy() {
            callStop();
        }

        // endregion

        // region public implementation

        function onAccept() {
            // IMPORTANT: we need to accept the call before opening the Call App,
            //  because as soon as you connect to the WebSockets you receive a call:request event for
            //  a pending call, resulting in a call modal being triggered inside popup window.
            return CallService.acceptCall(ctrl.meetingId).then(function () {
                ctrl.close(); // closes modal window

                return CallService.openCallAppWindow({
                    meetingId: ctrl.meetingId,
                    callType: ctrl.callType,
                });
            });
        }

        function onReject() {
            return CallService.rejectCall(ctrl.meetingId).then(function () {
                ctrl.dismiss({ $value: 'rejected' });
            });
        }

        function onEnded() {
            return CallService.endCall(ctrl.meetingId).then(function () {
                ctrl.dismiss({ $value: 'ended' });
            });
        }

        function onClose() {
            ctrl.dismiss({ $value: 'closed' });
            callStop();
        }

        // endregion

        // region private implementation

        /**
         * Updates the UI to achieve a call stop state.
         * Dont forget to stop ringer audio when call ends.
         */
        function callStop() {
            ctrl.callStatus = 'timeout';
        }

        // endregion
    }
})();
